import React from 'react';

import { Entity, RELATION_OWNED_BY } from '@backstage/catalog-model';
import { MarkdownContent } from '@backstage/core-components';
import {
  EntityRefLinks,
  getEntityRelations,
} from '@backstage/plugin-catalog-react';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { AboutField } from '../Components/AboutCard/AboutField';

const useStyles = makeStyles({
  description: {
    wordBreak: 'break-word',
  },
});

export interface AIToolsAboutContentProps {
  entity: Entity;
}

export function AIToolsAboutContent(props: Readonly<AIToolsAboutContentProps>) {
  const { entity } = props;
  const classes = useStyles();
  const ownedByRelations = getEntityRelations(entity, RELATION_OWNED_BY);

  return (
    <Grid container>
      <AboutField label="Description" gridSizes={{ xs: 12 }}>
        <MarkdownContent
          className={classes.description}
          content={entity?.metadata?.description || 'No description'}
        />
      </AboutField>

      <AboutField label="Owner" value="No Owner" gridSizes={{ xs: 12 }}>
        {ownedByRelations.length > 0 ? (
          <EntityRefLinks entityRefs={ownedByRelations} defaultKind="group" />
        ) : (
          (entity?.spec?.owner as string) || 'No Owner'
        )}
      </AboutField>
    </Grid>
  );
}
